var _rect, _rect2, _rect3, _rect4, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomizeMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 191,
    height: 191,
    stroke: "white",
    strokeOpacity: 0.07
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 40,
    fill: "#8A7CFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 40,
    fill: "url(#paint0_linear_97_7)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 188,
    height: 188,
    rx: 38,
    stroke: "white",
    strokeOpacity: 0.07,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.52 151.36L84.32 101.76C82.4188 99.2251 81.4682 97.9576 80.8834 96.519C80.6895 96.0419 80.5264 95.5528 80.3953 95.0548C80 93.553 80 91.9687 80 88.8V46.4C80 40.4004 80 37.4006 81.5279 35.2977C82.0213 34.6186 82.6186 34.0213 83.2977 33.5279C85.4006 32 88.4004 32 94.4 32H101.2C105.901 32 108.251 32 110.35 32.8161C111.042 33.0851 111.707 33.4179 112.337 33.8099C114.249 34.9989 115.659 36.8793 118.48 40.64L155.68 90.24C157.581 92.7749 158.532 94.0424 159.117 95.4811C159.311 95.9581 159.474 96.4472 159.605 96.9452C160 98.447 160 100.031 160 103.2V145.6C160 151.6 160 154.599 158.472 156.702C157.979 157.381 157.381 157.979 156.702 158.472C154.599 160 151.6 160 145.6 160H138.8C134.099 160 131.749 160 129.65 159.184C128.958 158.915 128.293 158.582 127.663 158.19C125.751 157.001 124.341 155.121 121.52 151.36Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 129.6C32 120.601 32 116.101 34.2918 112.947C35.032 111.928 35.9278 111.032 36.9466 110.292C40.101 108 44.6006 108 53.6 108H62.4C71.3994 108 75.899 108 79.0534 110.292C80.0722 111.032 80.968 111.928 81.7082 112.947C84 116.101 84 120.601 84 129.6V138.4C84 147.399 84 151.899 81.7082 155.053C80.968 156.072 80.0722 156.968 79.0534 157.708C75.899 160 71.3994 160 62.4 160H53.6C44.6006 160 40.101 160 36.9466 157.708C35.9278 156.968 35.032 156.072 34.2918 155.053C32 151.899 32 147.399 32 138.4V129.6Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_7",
    x1: 96,
    y1: 0,
    x2: 96,
    y2: 192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#8A7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomizeMark);
export default __webpack_public_path__ + "static/media/atomize_mark.372bc9bceed433e681623b597704655f.svg";
export { ForwardRef as ReactComponent };